import { render, staticRenderFns } from "./resetPwdDialog.vue?vue&type=template&id=3649ab60&scoped=true"
import script from "./resetPwdDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPwdDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./resetPwdDialog.vue?vue&type=style&index=0&id=3649ab60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3649ab60",
  null
  
)

export default component.exports